export default __webpack_public_path__ + "static/media/P3.748b4754.svg";